<template>
  <div class="route-unavailable">
    <el-result
      icon="warning"
      :title="`${pageTitle}暂不可用`"
      sub-title="菜单对应的页面组件尚未部署，请刷新重试或返回酒店首页。"
    >
      <template #extra>
        <div class="route-unavailable__actions">
          <el-button type="primary" @click="reload">刷新重试</el-button>
          <el-button @click="goHotelHome">返回酒店首页</el-button>
        </div>
        <code v-if="componentPath" class="route-unavailable__path">
          {{ componentPath }}
        </code>
      </template>
    </el-result>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

defineOptions({ name: 'RouteUnavailable' })

const route = useRoute()
const router = useRouter()
const pageTitle = computed(() => String(route.meta.title || '酒店页面'))
const componentPath = computed(() => String(route.meta.unavailableComponent || ''))

const reload = () => window.location.reload()
const goHotelHome = () => {
  const path = route.path.startsWith('/ai-Application-center/hotel')
    ? '/ai-Application-center/hotel/dashboard'
    : '/hotel/dashboard'
  router.push(path)
}
</script>

<style scoped>
.route-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 160px);
  background: #fff;
}

.route-unavailable__actions {
  margin-bottom: 18px;
}

.route-unavailable__path {
  display: inline-block;
  max-width: min(640px, 80vw);
  padding: 6px 10px;
  overflow-wrap: anywhere;
  font-size: 12px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
</style>
